import React, { useState, useCallback } from 'react';
import Button from 'shared/components/Button/Button';
import { formatDate } from 'utils/date';

import trackEvent from 'services/AnalyticsService';
import styles from '../Screens/CarInsurance.module.scss';

type Props = {
  details: WebExperienceApiContract.Models.CarinsurancePolicy
}

const MSG_URL = 'https://rac.insure-systems.co.uk/myaccount/'

const InsuranceSummaryFullDetails = ({ details }: Props) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleIsExpanded = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const openExternalLink = () => {
    trackEvent('MyRAC_CarInsurance_Manage_Cover')
    window.open(MSG_URL, '_blank', 'noopener,noreferrer');
  }

  return (
    <div className="accordion ps-3" id="carInsuranceAccordian">
      <div className="accordion-item">
        <h3 className={`accordion-header ${styles.sectionTitle}`}>
          <button className={`accordion-button ${isExpanded ? 'not-collapsed' : 'collapsed'}`} type="button" onClick={toggleIsExpanded}>Full details</button>
        </h3>
        <div className={`accordion-collapse collapse ${isExpanded ? 'show' : ''}`} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
          <div className="accordion-body">
            <div className="row">
              <div className="col-6">
                <h3 className={styles.sectionTitle}>Start date</h3>
                <p>{formatDate(details.policyStartDate, 'd MMM yyyy')}</p>
                <h3 className={styles.sectionTitle}>Cover type</h3>
                <p>{details.coverType}</p>
                <h3 className={styles.sectionTitle}>Annual Mileage</h3>
                <p>{details.mileage}</p>
              </div>
              <div className="col-6">
                <h3 className={styles.sectionTitle}>Address</h3>
                <p>{details.postcode}</p>
                <h3 className={styles.sectionTitle}>Total excess</h3>
                <p>£{details.excess}</p>
                <h3 className={styles.sectionTitle}>Use</h3>
                <p>{details.use}</p>
              </div>
              <div className="row">
                <div className="col-12">
                  <h3 className={styles.sectionTitle}>Extras</h3>
                  <p>{details.extras}</p>
                </div>
              </div>
            </div>
            <hr className={`${styles.divider} me-3`} />
            <div className="pb-3">
              {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
              {/* @ts-ignore */}
              <Button
                onClickHandler={openExternalLink}
                buttonText="Manage your cover"
                rounded
                small
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default InsuranceSummaryFullDetails;
